import {
  getProcessorOnboard,
  postProcessorOnboard,
  putProcessorOnboard,
  delProcessorOffboard,
  fetchOperation,
} from "utils/api";

export const getProcessorOnboardStatus = async (merchantId) => {
  return await getProcessorOnboard(`/status/${merchantId}`);
};

export const postProcessorOnboardMerchant = async (
  merchantId,
  processor,
  onboardType,
) => {
  const body = {
    merchantId,
    processors: [processor],
    onboardType: onboardType || "MAS_ONBOARD",
  };
  return await postProcessorOnboard("/merchants", body);
};

export const delProcessorOffboardMerchant = async (merchantId, processor) => {
  const body = {
    merchantId,
    processor,
  };
  return await delProcessorOffboard("/merchants", body);
};

export const checkAllinPayMultipleMid = async (merchantId) => {
  return await fetchOperation("/merchant/aip/check-multiple-mid", {
    merchantId: merchantId,
  });
};

export const batchUpdateGsi = async (params) => {
  return await postProcessorOnboard("/merchants/gsi/batch", {
    ...params,
  });
};

export const updateProcessorSpecificParams = async (
  merchantId,
  processor,
  processorSpecificParams,
) => {
  return await putProcessorOnboard("/merchants", {
    merchantId,
    processors: [processor],
    processorSpecificParams: {
      [processor]: processorSpecificParams,
    },
  });
};
